import { Component, OnInit ,ViewChild} from '@angular/core';
import { PlanNotificationComponent } from '../PlanNotification/PlanNotification.component';
import { AppNotificationService } from './AppNotification.service';
import { CommonapiService } from '../../Service/Commonapi.service';

@Component({
  selector: 'app-AppNotification',
  templateUrl: './AppNotification.component.html'
})
export class AppNotificationComponent implements OnInit {
  //@ViewChild('PlanNotificationComponentpage') echild: PlanNotificationComponent;
  showPlanNotification: boolean = false;
  @ViewChild('PlanNotificationComponentpage') echild: PlanNotificationComponent;
  constructor( private searchServiceapi: AppNotificationService, private api: CommonapiService) { }

  ngOnInit() {
  }
  notificationCount;
  overallCount;

  async GetNotificationCount() {

    var postdata = { "userId": "" };

    //this.Winfoapi.loader.startLoading();
    if (this.api.isLoggedin()){
      this.searchServiceapi.GetNotificationCount(postdata, false).then(data => {
        console.log("GetNotificationCount data", data)
        //undefined - bad request
        //[] - no records
        if (data && data != undefined && data != '[]') {
          //this.businessList = data;
          this.notificationCount = data.notification_count;
          //this.notificationCount = 5;
          this.overallCount = data.overall_count;

          if (data.is_active == "0") {
            this.searchServiceapi.api.Logout();
          }

        }
        // this.Winfoapi.loader.stopLoading();

      });
    }

  }

  async GetPlanNotificationList() {



    if (this.overallCount > 0) {
      //this.notificationCount = 0;
      $('#planNotificationPopup').addClass('pop_active_card');
      this.showPlanNotification = true;
      console.log('this.echild', this.echild);
      if (this.echild != undefined) {
        this.echild.GetPlanNotificationList();

      }
    }
    else {
      $('#planNotificationPopup').removeClass('pop_active_card');
      this.showPlanNotification = false;
    }


  }
  async ngAfterViewInit() {
    setTimeout(() => {
      this.GetNotificationCount();
    }, 2000);
  }
}
